import styled from "styled-components";

export const BackgroundImage = styled.div<{ url: string }>`
  background: url(${(props) => props.url}) no-repeat top center;
  background-attachment: fixed;
  background-size: 100% 100%;
`;
